// extracted by mini-css-extract-plugin
export default {"wrapper":"Ro-z","response":"So-z","error":"To-z","disabled":"Uo-z","buttons":"Vo-z","feedbackQuestionSection":"Wo-z","yesNoWrapper":"Xo-z"};